export { PreviewComponent } from './preview.component';
